export default __webpack_public_path__ + "images/c7a98540046d33d23e7285cc016dc9ef.png";